import { Link } from 'react-router-dom'
import SeoHead from '../components/SeoHead'
import { isPageSeoEnabled } from '../config/siteConfig'
import './Legal.css'

const Disclaimer = () => {
  const seoEnabled = isPageSeoEnabled('disclaimer')
  
  return (
    <div className="legal-page">
      <SeoHead
        title="Medical Disclaimer | SIBR Lifescience"
        description="Important medical disclaimer for SIBR Lifescience website. Information provided is for educational purposes only."
        canonical="/disclaimer"
        seoEnabled={seoEnabled}
      />
      
      <section className="legal-hero">
        <div className="container">
          <h1>Medical Disclaimer</h1>
          <p>Please read this important information carefully.</p>
        </div>
      </section>

      <section className="legal-content section">
        <div className="container">
          <div className="legal-wrapper">
            {/* Core Statement */}
            <div className="disclaimer-highlight">
              <div className="highlight-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
                </svg>
              </div>
              <p>
                The content on this website is provided for <strong>INFORMATIONAL PURPOSES ONLY</strong> and 
                is <strong>NOT</strong> intended as a substitute for professional medical advice, diagnosis, 
                or treatment. Always seek the advice of your physician or other qualified healthcare provider 
                with any questions you may have regarding a medical condition or medication.
              </p>
            </div>

            <article className="legal-article">
              <h2>General Information</h2>
              <p>
                SIBR Life Sciences Private Limited ("SIBR Lifescience," "we," "us," or "our") provides 
                information about our pharmaceutical products on this website for general informational 
                purposes. This information is not intended to be a substitute for professional medical 
                advice and should not be used for diagnosing or treating any health problem or disease.
              </p>

              <h2>User Responsibility</h2>
              <p>By using this website, you acknowledge and agree that:</p>
              <ul>
                <li>
                  You will <strong>consult a qualified healthcare professional</strong> before using any 
                  medication or supplement, including products manufactured by SIBR Lifescience.
                </li>
                <li>
                  You will <strong>not disregard professional medical advice</strong> or delay seeking 
                  treatment because of something you have read on this website.
                </li>
                <li>
                  You are <strong>solely responsible</strong> for any decisions or actions you take 
                  regarding your health based on information from this website.
                </li>
                <li>
                  You will <strong>read all product labels</strong> and follow the directions provided 
                  by your healthcare provider or pharmacist.
                </li>
                <li>
                  If you suspect you are having a medical emergency, you will <strong>call emergency 
                  services immediately</strong>.
                </li>
              </ul>

              <h2>Product Information</h2>
              <p>
                While we strive to provide accurate and up-to-date information about our products, 
                we cannot guarantee that all information on this website is complete, accurate, or 
                current. Product formulations, ingredients, and packaging may change without notice. 
                Always refer to the actual product packaging and consult with your pharmacist or 
                healthcare provider for the most current information.
              </p>

              <h2>No Doctor-Patient Relationship</h2>
              <p>
                The use of this website does not create a doctor-patient or healthcare 
                provider-patient relationship between you and SIBR Lifescience or any of its 
                employees, agents, or representatives. No information on this website should be 
                construed as medical advice.
              </p>

              <h2>Third-Party Content</h2>
              <p>
                This website may contain links to third-party websites, including healthcare 
                platforms like 1mg. SIBR Lifescience:
              </p>
              <ul>
                <li>Does not control the content, accuracy, or opinions expressed on third-party sites.</li>
                <li>Is not responsible for the availability or content of these external sites.</li>
                <li>Does not endorse any products, services, or information offered by third parties.</li>
                <li>Encourages users to read the terms, conditions, and privacy policies of any third-party 
                    site they visit.</li>
              </ul>

              <h2>Adverse Reactions</h2>
              <p>
                If you experience any adverse reaction or side effect from any of our products, 
                please contact your healthcare provider immediately. You may also report adverse 
                events to us at <a href="mailto:pharmacovigilance@sibrlifescience.com">pharmacovigilance@sibrlifescience.com</a> or 
                to the relevant regulatory authority.
              </p>

              <h2>Limitation of Liability</h2>
              <p>
                To the fullest extent permitted by law, SIBR Lifescience shall not be liable for 
                any damages arising from the use of or reliance on any information provided on 
                this website. This includes, but is not limited to, direct, indirect, incidental, 
                consequential, or punitive damages.
              </p>

              <h2>Changes to This Disclaimer</h2>
              <p>
                We reserve the right to update or modify this Medical Disclaimer at any time without 
                prior notice. Your continued use of this website following any changes constitutes 
                your acceptance of the revised disclaimer.
              </p>

              <h2>Contact Us</h2>
              <p>
                If you have any questions about this Medical Disclaimer, please contact us:
              </p>
              <address>
                <strong>SIBR Life Sciences Private Limited</strong><br />
                Email: <a href="mailto:info@sibrlifescience.com">info@sibrlifescience.com</a><br />
                <Link to="/contact">Contact Page</Link>
              </address>

              <p className="last-updated">
                <em>Last updated: December 2024</em>
              </p>
            </article>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Disclaimer

